module.exports = __webpack_public_path__ + "static/media/guide_card.2c1bc913.png";